import { defineStore } from 'pinia'
import { useUserStore } from '@/store/UserStore.js'

export const useInvitationStore = defineStore('invitation', {
    state: () => ({
        visible: false,
    }),

    actions: {
        async showIfNeeded() {
            const userStore = useUserStore()
            await userStore.fetchInvitations()
            if (userStore.invitations && userStore.invitations.length > 0) {
                this.visible = true
            }
        },

        close() {
            this.visible = false
        }
    }
})
